import React from 'react';
import AppRouter from './router/AppRouter';
import useDevice from 'hooks/useDevice';
import WidthNotSupportedPage from 'views/WidthNotSupportedPage';
import AppProviderContexts from 'contexts/app.contexts';
import { HelmetProvider } from 'react-helmet-async';

export default function App() {
  const { screenIsMinimumSupportedWidth } = useDevice();

  if (!screenIsMinimumSupportedWidth)
    return <WidthNotSupportedPage notPortalAccess />

  return (
    <AppProviderContexts>
      <HelmetProvider>
        <AppRouter />
      </HelmetProvider>
    </AppProviderContexts>
  );
}
